import { useQuery } from '@tanstack/react-query';
import { QueryFnData, UseQueryOpts } from '../../engine';
import { referralMany } from './key-fn';
import { useFromLoader } from '../router/loader';

export const useReferralMany = <
  SelectedData = QueryFnData<typeof referralMany>,
>(
  options?: Omit<
    UseQueryOpts<typeof referralMany, SelectedData>,
    'initialData'
  >,
) => {
  const initialData = useFromLoader();

  return useQuery({
    ...referralMany(),
    ...options,
    initialData,
  });
};
